import React from "react"
import { LocalizedMatch } from "../../../types/match"
import { List } from "antd"
import { MatchListElement } from "@components/Match/MatchListElement"

export function MatchList({ matches }: { matches: LocalizedMatch[] }) {
  return <List dataSource={matches} renderItem={(match) => <MatchListElement match={match} />} />
}
